import React from 'react';

const HomeGardenColour = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4136_303)">
            <g clipPath="url(#clip1_4136_303)">
                <path
                    d="M12 14C15.0376 14 17.5 11.5376 17.5 8.5C17.5 5.46243 15.0376 3 12 3C8.96243 3 6.5 5.46243 6.5 8.5C6.5 11.5376 8.96243 14 12 14Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.2483 10.1477C18.0844 10.3416 18.8635 10.7287 19.5231 11.2778C20.1828 11.8269 20.7047 12.5228 21.0471 13.3099C21.3895 14.0969 21.5428 14.9532 21.4948 15.8101C21.4468 16.6671 21.1988 17.5009 20.7707 18.2448C20.3426 18.9887 19.7462 19.622 19.0294 20.094C18.3125 20.5661 17.4951 20.8637 16.6426 20.963C15.7901 21.0624 14.9261 20.9608 14.1199 20.6663C13.3138 20.3718 12.5877 19.8926 12 19.2671"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.75167 10.1477C5.67711 10.3998 4.70339 10.9697 3.95741 11.7832C3.21144 12.5966 2.72779 13.6159 2.56949 14.7083C2.4112 15.8006 2.5856 16.9153 3.06997 17.907C3.55434 18.8988 4.32622 19.7217 5.28502 20.2684C6.24382 20.8151 7.34507 21.0604 8.44527 20.9722C9.54548 20.884 10.5936 20.4665 11.4531 19.774C12.3125 19.0815 12.9435 18.1462 13.2637 17.0899C13.5839 16.0337 13.5785 14.9054 13.2482 13.8523"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4136_303">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4136_303">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default HomeGardenColour;
